import React from 'react';
import './ProjectLoadError.css';

function StatusIcon({ accessDenied, ...props }) {
	return (
		<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
			{accessDenied ? <>
				<rect x="5" y="10" width="14" height="11" rx="2.5" />
				<path d="M8 10V7a4 4 0 0 1 8 0v3M12 14.5v2" />
			</> : <>
				<circle cx="12" cy="12" r="9" />
				<path d="M12 7.5v5M12 16.5h.01" />
			</>}
		</svg>
	);
}

function ProjectIllustration({ accessDenied }) {
	return (
		<div className="project-access-art" aria-hidden="true">
			<div className="project-access-orbit project-access-orbit-outer" />
			<div className="project-access-orbit project-access-orbit-inner" />
			<div className="project-access-window">
				<div className="project-access-window-bar"><i /><i /><i /><span /></div>
				<div className="project-access-window-body">
					<div className="project-access-sidebar"><i /><i /><i /><i /></div>
					<div className="project-access-preview">
						<div className="project-access-preview-heading" />
						<div className="project-access-preview-line" />
						<div className="project-access-preview-cards"><i /><i /></div>
						<div className="project-access-preview-line" />
					</div>
				</div>
			</div>
			<div className="project-access-lock"><StatusIcon accessDenied={accessDenied} /></div>
			<div className="project-access-status">
				<span />{accessDenied ? 'Protected project' : 'Project unavailable'}
			</div>
			<span className="project-access-spark project-access-spark-one" />
			<span className="project-access-spark project-access-spark-two" />
		</div>
	);
}

export default function ProjectLoadError({ accessDenied }) {
	return (
		<div className="project-access-page">
			<header className="project-access-header">
				<a href="/" aria-label="Appmaker home" className="project-access-brand">
					<img src={`${process.env.PUBLIC_URL || ''}/images/appmaker-logo.svg`} width="150" height="40" alt="Appmaker" />
				</a>
				<a href="/" className="project-access-header-label">Console</a>
			</header>
			<main className="project-access-main" aria-labelledby="project-access-title">
				<div className="project-access-copy">
					<div className="project-access-eyebrow"><span />{accessDenied ? 'Project access' : 'Something went wrong'}</div>
					<div role="alert">
						<h1 id="project-access-title">{accessDenied ? 'Unauthorized access' : 'Unable to load this project'}</h1>
						<p className="project-access-description">
							{accessDenied
								? "You don’t have permission to open this project, or it’s no longer available. You can still get back to your other apps."
								: 'We couldn’t load your project right now. Please try again, or head back to your apps.'}
						</p>
					</div>
					<div className="project-access-actions">
						<a href="/" className="project-access-primary">
							<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m8 5-5 5 5 5M3 10h14" /></svg>
							Back to my apps
						</a>
						{!accessDenied && <button type="button" onClick={() => window.location.reload()} className="project-access-retry">Try again</button>}
					</div>
					{accessDenied && <div className="project-access-help">
						<StatusIcon accessDenied />
						<p><strong>Need access to this project?</strong><br />Ask the project owner to grant access to your account.</p>
					</div>}
				</div>
				<ProjectIllustration accessDenied={accessDenied} />
			</main>
			<footer className="project-access-footer"><a href="/" className="project-access-footer-link">Appmaker Console</a><span>Your apps. Your possibilities.</span></footer>
		</div>
	);
}
